import React from 'react';

import LiquidFertiliserIcon from './liquid-fertiliser-icon.svg?react';

export default function FarmbotLiquidFertiliserIcon() {
  return <LiquidFertiliserIcon width={18} />;
}
